import {
 NEW_PASSWORD_FAIL,
 NEW_PASSWORD_REQUEST,
 NEW_PASSWORD_SUCCESS,
} from "../../constants/actions";
import { postData } from "../../../services/api";
import { ApiURLs } from "../../../constant/ApiUrls";
import { NavigationRoutes } from "../../../constant/Routes";


export const newPasswordRequest = (data, navigate) => {
  return async (dispatch) => {

    dispatch(newPassRequest());
    try {
      var newPasswordData = await postData(data, ApiURLs.RESET_NEW_PASSWORD);
      if (newPasswordData.status === 1) {
        dispatch(newPassReqSuccess());
       navigate(NavigationRoutes.LOGIN,{ replace: true })
      } else {
        dispatch(newPassReqFail());
      }
    } catch (error) {
      dispatch(newPassReqFail());

    }
  };
};

export const newPassRequest = () => {
  return {
    type:NEW_PASSWORD_REQUEST,
  };
};

export const newPassReqSuccess = () => {
  return {
    type:NEW_PASSWORD_SUCCESS,
  };
};

export const newPassReqFail = (error) => {
  return {
    type:NEW_PASSWORD_FAIL,
    payload: error,
  };
};
